var path = 'src/app/patients/pathology/pathology.html';
var html = "<h1 class=page-header>Pathology</h1> <div pathology-component patient=patient></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/pathology/pathology.html
 ** module id = 551
 ** module chunks = 0
 **/